import i18n from "i18next";

export const defaultNotificationTypes = () => {
  return [
    { value: "alert", label: i18n.t("notification.alert"), icon: "warning", className: "--warning" },
    { value: "info", label: i18n.t("notification.info"), icon: "info", className: "--info" }
  ];
};

export const getNotificationType = messageType => {
  return defaultNotificationTypes().find(type => type.value === messageType);
};

export const addNotificationReadFlag = notifications => {
  localStorage.setItem("ids_notification", notifications.map(notification => notification.id));
};

export const hasNewNotifications = notifications => {
  const ids = localStorage.getItem("ids_notification") || [];
  return notifications.some(x => !ids.includes(x.id));
};



// WEBPACK FOOTER //
// ./src/helpers/notificationHelpers.js